import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Snackbar,
  Container,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import TBAdminTopNav from "./TBAdminTopNav";

const AddData = () => {
  const [title, setTitle] = useState("");
  const [viewLink, setViewLink] = useState("");
  const [favorite, setFavorite] = useState(false);
  const [organization, setOrganization] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const snapshot = await getDocs(collection(db, "organizations"));
        const orgList = snapshot.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().name,
        }));
        setOrganizations(orgList);
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };

    fetchOrganizations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !viewLink || !organization) {
      setSnackbar({
        open: true,
        message: "Please fill in all required fields.",
        severity: "error",
      });
      return;
    }

    try {
      await addDoc(collection(db, "data"), {
        title,
        viewLink,
        favorite,
        organization, // Save organization ID or name here
      });

      setSnackbar({
        open: true,
        message: "Dataset added successfully!",
        severity: "success",
      });

      setTitle("");
      setViewLink("");
      setFavorite(false);
      setOrganization("");
    } catch (error) {
      console.error("Error adding dataset:", error);
      setSnackbar({
        open: true,
        message: "Failed to add dataset.",
        severity: "error",
      });
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <TBAdminTopNav />
      <Typography variant="h5" gutterBottom>
        Add New Dataset
      </Typography>
      <form onSubmit={handleSubmit}>
  <FormControl fullWidth margin="normal" required>
    <InputLabel>Organization</InputLabel>
    <Select
      value={organization}
      onChange={(e) => setOrganization(e.target.value)}
    >
      {organizations.map((org) => (
        <MenuItem key={org.id} value={org.id}>
          {org.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

  <TextField
    label="Dataset Title"
    fullWidth
    margin="normal"
    value={title}
    onChange={(e) => setTitle(e.target.value)}
  />

  <TextField
    label="View Link (Google Sheet or Superset)"
    fullWidth
    margin="normal"
    value={viewLink}
    onChange={(e) => setViewLink(e.target.value)}
  />

  <Box mt={2}>
    <FormControlLabel
      control={
        <Checkbox
          checked={favorite}
          onChange={(e) => setFavorite(e.target.checked)}
        />
      }
      label="Mark as Favorite"
    />
  </Box>

  <Box mt={2}>
    <Button type="submit" variant="contained" color="primary">
      Add Dataset
    </Button>
  </Box>
</form>


      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Container>
  );
};

export default AddData;
